import {History, Long} from "@app/graphql-typings/graphql";
import {Transform, Type} from "class-transformer";
import moment, {Moment} from 'moment-timezone';

export class HistoryImpl implements History {
  fav_id: Long /* Unique identifier for a Favourite. */;
  data: number /* Value for the Favourite. */;
  @Type(() => moment)
  @Transform(({value}: { value: string | null }) => value ? moment.parseZone(value) : value, {toClassOnly: true})
  @Transform(({value}: { value: Moment | null }) => value ? value.toJSON() : value, {toPlainOnly: true})
  ts: Moment /* Timestamp when the data occurred. */;
}
